import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { IExtendedCookieService } from './extended-cookie-service.interface';

@Injectable()
export class ExtendedCookieService
    extends CookieService
    implements IExtendedCookieService {}
